import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 36,
			rx: 3,
			fill: "#7262FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3562 13.5749H24.3836C25.212 13.5749 25.7269 14.4553 25.3105 15.1516L17.4298 28.4663C17.2327 28.7992 16.8745 28.9919 16.4984 28.9919C15.8133 28.9919 15.2939 28.3656 15.4551 27.6998L17.5193 19.181L19.3562 13.5749Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.053 8.31946L19.2751 13.9905L17.4275 19.583H12.0814C11.4283 19.583 10.9239 19.0237 11.0095 18.3946L12.4507 7.90877C12.5228 7.38885 12.9822 7 13.5226 7H20.0081C20.7153 7 21.2332 7.65537 21.053 8.31946Z",
			fill: "white"
		})
	]
});
export default SvgLogoIcon;
